import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import PromoterListLayerNew from "../../components/User/UserListLayer";

const PromoterList = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>
        {/* Breadcrumb */}
        <Breadcrumb title="Promoter Management" />

        <PromoterListLayerNew roles="promoter"/>
      </MasterLayout>
    </>
  );
};

export default PromoterList;
